import request from './request'

//  已登录查询活动配置
export const configDetail = (params: any) =>
  request({
    url: '/carbon-promotion/private/user/activity/red/envelope/rain/homepage',
    method: 'GET',
    params,
  })
//  未登录查询活动配置
export const configDetailWithoutAuth = (params: any) =>
  request({
    url: '/carbon-promotion/public/activity/red/envelope/rain/homepage',
    method: 'GET',
    params,
  })

// 获取红包中奖数据
export const getRedPackageAwardData = (params: any) =>
  request({
    url: '/carbon-promotion/public/activity/red/envelope/rain/reward/list',
    method: 'GET',
    params,
  })
